import { apiGet, apiPost, apiPatch, apiDelete } from './httpClient'

export async function listScenarios(params = {}, signal) {
  const query = new URLSearchParams(params).toString()
  const data = await apiGet(`/scenarios/${query ? `?${query}` : ''}`, { signal })
  return Array.isArray(data) ? data : (data.results || [])
}

export async function getScenario(id, signal) {
  return apiGet(`/scenarios/${id}/`, { signal })
}

export async function createScenario(data) {
  return apiPost('/scenarios/', data)
}

export async function updateScenario(id, data) {
  return apiPatch(`/scenarios/${id}/`, data)
}

export async function deleteScenario(id) {
  await apiDelete(`/scenarios/${id}/`)
  return true
}

export async function runScenario(id, params = {}) {
  return apiPost(`/scenarios/${id}/run/`, params)
}

export async function listSimulations(params = {}, signal) {
  const data = await apiGet('/simulations/', { signal, query: params })
  return Array.isArray(data) ? data : (data.results || [])
}
